
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealCategoryEntity } from '../../domain/entities/MealCategoryEntity'
export class MealCategoryModel extends MealCategoryEntity {
  constructor(dataDto: MealCategoryModel) {
    super()
    mapEntityProperties<MealCategoryEntity>(this, dataDto)
  }
}